import { Component, Input, OnInit } from '@angular/core';
import { AlarmOverview, Application } from '../../../interfaces/alarm';
import { Observable } from 'rxjs';
import { Installation } from '../../../interfaces/facilty';
import { AppModel } from '@ams/dumbledore';
import { DataPointsResult, SystemDevice } from '../../../interfaces/data-points';
import { PumpOption } from '../../../services/installation-configuration.service';
import { SchematicsService } from '../../../services/schematics.service';
import { getPumpOptions, getPumpType, systemsToPumpDevice } from '../../../utils/data-point-utils';
import { PasteurizationStatusTileComponent } from '../../pasteurization-status-tile/pasteurization-status-tile.component';
import { MixitX509BannerComponent } from '../../mixit-x509-banner/mixit-x509-banner.component';
import { AsyncPipe } from '@angular/common';
import { AlarmBarComponent } from '../../alarms/alarm-bar/alarm-bar.component';
import { SchematicsTileComponent } from '../../schematics-tile/schematics-tile.component';
import { SetpointTileComponent } from '../../setpoint-tile/setpoint-tile.component';
import { PumpStatusTileComponent } from '../../pump-status-tile/pump-status-tile.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-commercial-hot-water-dashboard-standalone',
    templateUrl: './commercial-hot-water-dashboard-standalone.component.html',
    styleUrls: ['./commercial-hot-water-dashboard-standalone.component.scss'],
    imports: [
    PasteurizationStatusTileComponent,
    MixitX509BannerComponent,
    AlarmBarComponent,
    SchematicsTileComponent,
    SetpointTileComponent,
    PumpStatusTileComponent,
    TranslateModule,
    AsyncPipe
]
})
export class CommercialHotWaterDashboardStandaloneComponent implements OnInit {
  @Input() public alarm$: Observable<AlarmOverview>;
  @Input() public application: Application;
  @Input() public installation$: Observable<Installation>;
  @Input() public schematic$: Observable<AppModel>;
  @Input() public dataPoints$: Observable<DataPointsResult>;

  public pumpDevice$: Observable<SystemDevice | undefined>;
  public pumpType$: Observable<string>;
  public pumpOptions$: Observable<PumpOption[] | undefined>;

  constructor(private schematicsService: SchematicsService) {}

  ngOnInit(): void {
    this.pumpDevice$ = this.dataPoints$.pipe(systemsToPumpDevice(this.application.id));

    this.pumpType$ = getPumpType(this.schematic$, this.application.id);

    this.pumpOptions$ = getPumpOptions(this.pumpDevice$, this.schematicsService, this.application.id);
  }
}
